import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("LinksFooterWidget", {
  title: "Links footer widget",
  attributes: {
    title: {
      title: "Title",
    },
    links: {
      title: "Links",
    },
  },
  properties: ["title", "links"],
});
